
/**
 * Classe CommandParam
 * Valori per 'server injection'
 * $UserID (0)-> verrà cercato il campo $UserID nel dictionary
 * contenente il codice utente della sessione corrente
 *
 * $SessionID (0)-> ID Sessione
 * $WeKey (100)(-> ID/Chiave sito
 * $Jwt (2000)-> Token client
 *
 * $ReferrerAutority (2000)-> Authority di provenienza della richiesta (Sito che contatta)
 * $Autority (2000)-> Sito contattato
 * $RemoteHost (2000)-> indirizzo IP
 * $WebServerDateTime (2000)-> Date Time del server web , non aggiungo questo parametro ma lo gestisco
 */
export class CommandParam {
  constructor(Name, RName, Type, Length, Direction, Value, SaveUTCDate) {
    if (Name != undefined && typeof Name == "string") {
      this.Name = Name;
    } else {
      this.Name = "";
    }

    if (RName != undefined && typeof RName == "string") {
      this.RName = RName;
    } else {
      this.RName = "";
    }

    if (Type != undefined && typeof Type == "number") {
      this.Type = Type;
    } else {
      this.Type = 0;
    }

    if (Length != undefined && typeof Length == "number") {
      this.Length = Length;
    } else {
      this.Length = 0;
    }

    if (Direction != undefined && typeof Direction == "number") {
      this.Direction = Direction;
    } else {
      this.Direction = 0;
    }

    if (Value == undefined) {
      this.Value = null;
    } else {
      this.Value = Value;

      //se trattasi di una data genero l'offset
      if (Object.prototype.toString.call(Value) === "[object Date]") {
        this.LocalTimeOffset = new Date(Value).getTimezoneOffset();
      }
    }

    if (SaveUTCDate != undefined && typeof SaveUTCDate == "boolean") {
      this.SaveUTCDate = SaveUTCDate;
    } else {
      this.SaveUTCDate = false;
    }
  }
}
